export default __webpack_public_path__ + "static/media/9b8892e3f64527583e3f2682889477b1.7cfe3a2b.jpeg";